module.exports = __webpack_public_path__ + "img/no-product.05e31762.png";